import React from 'react';
import firts from '../first.png';

import Grid from './Grid';

class Tabletselect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
           
        }

    }
   
    render() {

        let loader = <div className="lds-facebook"><div></div><div></div><div></div></div>;

        return (
            <div className={this.props.raw.leagues ? "tabletselect mb-3" : "mb-3"}>
                <div id="proximos" >
                    {/* promo */}
                    <div className={(this.props.raw.leagues) ? "d-none " : (!this.props.loading ? "row" : "d-none")}>
                        <div className="col-md-6 d-none" style={{ backgroundImage: firts }}>
                            <div className="card sports-highlights">
                                <h5 className="card-header"><i className="fas fa-gift"></i> {this.props.language().bonoHeader}</h5>
                                <div className="card-body" style={{ backgroundImage: firts }}>
                                    <h5 className="card-title">{this.props.language().bonoHeader}</h5>
                                    <p className="card-text"> <i className="fas fa-gift"></i> {this.props.language().bonoText}</p>
                                    <div className="btn btn-success">{this.props.language().deposit}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 d-none" style={{ backgroundImage: firts }}>
                            <div className="card sports-highlights" style={{ borderTop: '2px solid white' }}>
                                <h5 className="card-header"><i className="fab fa-facebook-square"></i> {this.props.language().promoHeader}</h5>
                                <div className="card-body" style={{ backgroundImage: firts }}>
                                    <h5 className="card-title">{this.props.language().promoTitle}</h5>
                                    <p className="card-text">  {this.props.language().promoText}</p>
                                    <div className="col-sm-12">


                                        <div className="text-center text-md-right">
                                            <ul className="list-unstyled list-inline">
                                                <li className="list-inline-item">
                                                    <a href="https://fb.me/griffonBets" target="_new" className="btn-floating btn-sm  mx-1">
                                                        <i className="fab fa-facebook"></i>
                                                    </a>
                                                </li>
                                                <li className="list-inline-item">
                                                    <a target="_new" className="btn-floating btn-sm rgba-white-slight mx-1">
                                                        <i className="fab fa-twitter"></i>
                                                    </a>
                                                </li>
                                                <li className="list-inline-item">
                                                    <a target="_new" className="btn-floating btn-sm rgba-white-slight mx-1">
                                                        <i className="fab fa-google-plus"></i>
                                                    </a>
                                                </li>
                                                <li className="list-inline-item">
                                                    <a target="_new" className="btn-floating btn-sm rgba-white-slight mx-1">
                                                        <i className="fab fa-linkedin"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* selected */}
                    <div className={(this.props.raw.leagues && !this.props.loading) ? "card-header" : "d-none"} role="alert">
                        <h5>
                            <span><i className="fas fa-award"></i> {this.props.tableheader ? this.props.language().bets + " " + this.props.tableheader : ""}</span>
                        </h5>
                    </div>
                    {/* close btn */}
                    <div className={(this.props.raw.leagues && !this.props.loading) ? "btn" : "d-none"} style={{
                        marginTop: -47,
                        position: "absolute",
                        marginRight: 10, fontSize: 20, padding: 5,
                        // boxShadow: "2px 2px black",
                        right: 20,
                        color: "white", fontWeight: "bolder",
                        float: "right", display: this.props.tableheader ? "" : "none"
                    }} onClick={this.props.close}>
                        <i className="far fa-window-close"></i>
                    </div>
                </div>
                <div className={"accordion"} id="accordionExample" style={{ textAlign: "center" }}>
                    {!this.props.loading ?
                        <Grid
                            raw={this.props.raw}
                            items={this.props.items}
                            addTocart={this.props.addTocart}
                            format={this.props.format}
                            language={this.props.language}
                        /> : loader}
                </div>
            </div>


        )

    }
}


export default Tabletselect;


// WEBPACK FOOTER //
// ./src/components/Tabletselect.js